export default {
  init() {

  },
  finalize() {
    $('.team-member-item').each(function() {
      $(this).find('.team-member-bio-toggle').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).siblings('.team-member-bio-wrap').toggleClass('show');
        $(this).toggleClass('expanded');
      });
    })
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateMeetTheTeam.js